const posComponentLoaders = Object.freeze({
  'pos.order-workspace': async () => {
    const module = await import('./pos-workspace-component.js');
    return module.PosWorkspaceComponent;
  },
});

export default posComponentLoaders;
